var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Mutation as ApolloMutation } from "react-apollo";
import getErrorMsg from "./helpers/getErrorMsg";
var Mutation = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ApolloMutation, __assign({}, props), function (mutation, apollo) { return children(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return mutation.apply(void 0, args);
    }, __assign(__assign({}, apollo), { errorMsg: getErrorMsg(apollo, props.errorHandler) })); }));
};
export default Mutation;
